'use strict';exports.__esModule = true;var getButtonsConfig = function getButtonsConfig(props, handlers) {var


  is_active =


  props.property.is_active,translate = props.translate;

  var activeInactiveTitle = void 0;
  var activeInactiveText = void 0;
  var activeInactiveIcon = void 0;

  if (is_active) {
    activeInactiveTitle = 'makeInactive';
    activeInactiveText = 'deactivate';
    activeInactiveIcon = 'active';
  } else {
    activeInactiveTitle = 'makeActive';
    activeInactiveText = 'activate';
    activeInactiveIcon = 'inactive';
  }

  return {
    edit: {
      props: {
        onClick: handlers.handleEdit },

      icon: 'edit',
      title: translate('edit') },

    preview: {
      props: {
        onClick: handlers.openDetailsPopup },

      icon: 'preview',
      title: translate('openDetails') },

    activity: {
      props: {
        onClick: handlers.toggleActivity,
        title: translate('propertyDetails', activeInactiveTitle) },

      icon: 'check-circle ' + activeInactiveIcon,
      title: translate('propertyDetails', activeInactiveText) } };


};exports.default =

getButtonsConfig;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/OMAgentManageCell/config.js
// module id = 2762
// module chunks = 0